import { Injectable } from '@angular/core';
import { EstimateDTO } from '../models/estimate-dto';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { estimateTypeDTO } from '../models/estimate-type-dto';
import { BinTagBatchDTO } from '../models/bin-tag-batch-dto';
import { EstimateDTOGrouping } from '../models/estimate-dto-groupings';
import { estimateTypeLock } from '../models/estimate-type-lock';

@Injectable({
  providedIn: 'root'
})
export class EstimatesService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getEstimateTypes(includeInactive: boolean = false): Observable<estimateTypeDTO[]> {
    let queryParameters = new HttpParams();

    queryParameters.append('includeInactive', includeInactive.toString());

    return this.httpClient.get<estimateTypeDTO[]>(`${this.basePath}/api/estimateTypes`);
  }

  public postEstimateType(estimate: estimateTypeDTO): Observable<estimateTypeDTO> {
    return this.httpClient.post<estimateTypeDTO>(`${this.basePath}/api/EstimateTypes`, estimate);
  }

  public putEstimateType(estimate: estimateTypeDTO): Observable<estimateTypeDTO> {
    return this.httpClient.put<estimateTypeDTO>(`${this.basePath}/api/EstimateTypes/UpdateEstimateType/${estimate.id}`, estimate);
  }
  public deleteEstimateType(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/EstimateTypes/${id}`);
  }

  public getEstimateDTOs(includeInactive: boolean = false, cropYearId?: number): Observable<EstimateDTO[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('includeInactive', includeInactive.toString());

    if (cropYearId)
      queryParameters = queryParameters.append('cropYearId', cropYearId.toString());

    return this.httpClient.get<EstimateDTO[]>(`${this.basePath}/api/estimates`,
      {
        params: queryParameters
      }
    );
  }

  public getEstimatesGroupings(includeInactive: boolean = false, cropYearId?: number): Observable<EstimateDTOGrouping[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('includeInactive', includeInactive.toString());

    if (cropYearId)
      queryParameters = queryParameters.append('cropYearId', cropYearId.toString());

    return this.httpClient.get<EstimateDTOGrouping[]>(`${this.basePath}/api/estimates/variety?groupByBlock=true`,
      {
        params: queryParameters
      }
    );
  }

  public putEstimateDTO(estimate: EstimateDTO): Observable<EstimateDTO[]> {
    return this.httpClient.put<EstimateDTO[]>(`${this.basePath}/api/estimates/${estimate.id}`, estimate);
  }

  public getMostRecentEstimate(blockId: number): Observable<EstimateDTO> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('blockId', blockId.toString());

    return this.httpClient.get<EstimateDTO>(`${this.basePath}/api/Estimates/mostrecent`,
      {
        params: queryParameters
      }
    );
  }

  public getYoYActuals(blockId: number): Observable<EstimateDTO[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('blockId', blockId.toString());

    return this.httpClient.get<EstimateDTO[]>(`${this.basePath}/api/Estimates/yoyActuals`,
      {
        params: queryParameters
      }
    );
  }

  public getEstimateDTO(id: number): Observable<EstimateDTO> {
    return this.httpClient.get<EstimateDTO>(`${this.basePath}/api/Estimates/${id}`);
  }

  public deleteEstimateDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/Estimates/${id}`);
  }

  public postEstimateDTO(estimate: EstimateDTO): Observable<EstimateDTO> {
    return this.httpClient.post<EstimateDTO>(`${this.basePath}/api/estimates`, estimate);
  }




  //Estimate Type Locks -----------------------------------------------------------------


  // ─── Admin tenant-scoped EstimateType endpoints ──────────────────────────

  public getEstimateTypesForTenant(tenantId: string): Observable<estimateTypeDTO[]> {
    return this.httpClient.get<estimateTypeDTO[]>(
      `${this.basePath}/api/EstimateTypes/tenant/${encodeURIComponent(tenantId)}`
    );
  }

  public getEstimateTypeForTenant(tenantId: string, id: number): Observable<estimateTypeDTO> {
    return this.httpClient.get<estimateTypeDTO>(
      `${this.basePath}/api/EstimateTypes/tenant/${encodeURIComponent(tenantId)}/${id}`
    );
  }

  public postEstimateTypeForTenant(tenantId: string, dto: estimateTypeDTO): Observable<estimateTypeDTO> {
    return this.httpClient.post<estimateTypeDTO>(
      `${this.basePath}/api/EstimateTypes/tenant/${encodeURIComponent(tenantId)}`, dto
    );
  }

  public putEstimateTypeForTenant(tenantId: string, dto: estimateTypeDTO): Observable<void> {
    return this.httpClient.put<void>(
      `${this.basePath}/api/EstimateTypes/tenant/${encodeURIComponent(tenantId)}/${dto.id}`, dto
    );
  }

  public deleteEstimateTypeForTenant(tenantId: string, id: number): Observable<any> {
    return this.httpClient.delete(
      `${this.basePath}/api/EstimateTypes/tenant/${encodeURIComponent(tenantId)}/${id}`
    );
  }

  // ─── Estimate Type Locks ──────────────────────────────────────────────────

  public getEstimateTypeLocks(includeInactive: boolean = true): Observable<estimateTypeLock[]> {

    let queryParameters = new HttpParams();

    queryParameters.append('includeInactive', includeInactive.toString());

    return this.httpClient.get<estimateTypeLock[]>(`${this.basePath}/api/estimateTypes/TypeLocks`);
  }

  public getLocksByYear(cropYearId: number): Observable<estimateTypeLock[]> {
    return this.httpClient.get<estimateTypeLock[]>(`${this.basePath}/api/estimateTypes/TypeLocks/${cropYearId}`);
  }

  public putEstimateTypeLock(estimateTypeLock: estimateTypeLock): Observable<estimateTypeLock[]> {
    return this.httpClient.put<estimateTypeLock[]>(`${this.basePath}/api/estimateTypes/TypeLocks/${estimateTypeLock.id}`, estimateTypeLock);
  }

}
